import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import axios from "axios";

export interface SubmitWiderrufPayload {
  firstName: string;
  lastName: string;
  orderNumber: string;
  email: string;
  notice: string;
  website: string;
}

@Module({
  name: "widerruf",
  namespaced: true,
  stateFactory: true,
})
export default class WiderrufStore extends VuexModule {
  errorMessage = "";
  // UTC ISO instant of the receipt; the view formats it to Europe/Berlin.
  receivedAt: string | null = null;

  @Mutation
  setErrorMessage(message: string) {
    this.errorMessage = message;
  }

  @Mutation
  setReceivedAt(data: string | null) {
    this.receivedAt = data;
  }

  @Action
  async submitWiderruf(payload: SubmitWiderrufPayload): Promise<boolean> {
    try {
      const result = await axios({
        method: "post",
        url: `${process.env.BACKBONE_ESYOIL}${
          process.env.WIDERRUF_SUBMISSION || "/order/widerruf/v1"
        }`,
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
        data: {
          firstName: payload.firstName,
          lastName: payload.lastName,
          orderNumber: payload.orderNumber,
          email: payload.email,
          notice: payload.notice,
          website: payload.website,
        },
      });
      this.context.commit("setReceivedAt", result.data.receivedAt);
      this.context.commit("setErrorMessage", "");
      return true;
    } catch (error) {
      console.error("Widerruf submit error", error);
      const response = (
        error as { response?: { status?: number; data?: { message?: string } } }
      ).response;
      const backendMessage = response?.data?.message;
      this.context.commit(
        "setErrorMessage",
        response?.status === 429 && backendMessage
          ? backendMessage
          : "Ihr Widerruf konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.",
      );
      return false;
    }
  }
}
